<template>
  <div class="home">
    <!-- 顶部5个模块 -->
    <div class="header">
      <div class="item item1">
        <div class="item_title">总入场人数</div>
        <div class="number">
          <img src="@/assets/image/icon_rcre.png" alt="总入场人数" />
          <a-statistic
            :value="allp"
            :value-style="{ color: '#FFF', fontSize: '32px' }"
          >
            <template #suffix>
              <span> / 人</span>
            </template>
          </a-statistic>
        </div>
        <div class="label">本周入场人数</div>
        <Echart
          height="38px"
          domid="labelEchart1"
          :option="labelEchart1"
        ></Echart>
      </div>
      <div class="item item2">
        <div class="item_title">目前在场人数</div>
        <div class="number">
          <img src="@/assets/image/icon_zcrs.png" alt="目前在场人数" />
          <a-statistic
            :value="allpi"
            :value-style="{ color: '#FFF', fontSize: '32px' }"
          >
            <template #suffix>
              <span> / 人</span>
            </template>
          </a-statistic>
        </div>
        <div class="label">今日实时在场人数</div>
        <Echart
          height="38px"
          domid="labelEchart2"
          :option="labelEchart1"
        ></Echart>
      </div>
      <div class="item item3">
        <div class="item_title">黄码人数</div>
        <div class="number">
          <img src="@/assets/image/icon_hm.png" alt="黄码人数" />
          <a-statistic
            :value="allye"
            :value-style="{ color: '#FFF', fontSize: '32px' }"
          >
            <template #suffix>
              <span> / 人</span>
            </template>
          </a-statistic>
        </div>
        <div class="two">
          <div class="label">黄码占比</div>
          <a-progress
            type="circle"
            :width="88"
            stroke-color="#FFF"
            :percent="yevalue"
            status="active"
            :strokeWidth="10"
          >
            <template #format="percent">
              <span style="color: #fff; font-size: 14px">{{ percent }}%</span>
            </template></a-progress
          >
        </div>
      </div>
      <div class="item item4">
        <div class="item_title">绿码人数</div>
        <div class="number">
          <img src="@/assets/image/icon_lmrs.png" alt="绿码人数" />
          <a-statistic
            :value="allgr"
            :value-style="{ color: '#FFF', fontSize: '32px' }"
          >
            <template #suffix>
              <span> / 人</span>
            </template>
          </a-statistic>
        </div>
        <div class="two">
          <div class="label">绿码占比</div>
          <a-progress
            type="circle"
            :width="88"
            stroke-color="#FFF"
            :percent="grvalue"
            status="active"
            :strokeWidth="10"
          >
            <template #format="percent">
              <span style="color: #fff; font-size: 14px">{{ percent }}%</span>
            </template></a-progress
          >
        </div>
      </div>
      <div class="item item5">
        <!-- <div class="item_title"></div> -->
        <div class="number">
          <img src="@/assets/image/icon_lmrss.png" alt="台数" />
          <a-statistic
            :value="allins.length"
            :value-style="{ color: '#000', fontSize: '32px' }"
          >
            <template #suffix>
              <span> / 台</span>
            </template>
          </a-statistic>
        </div>
        <div class="list">
          <div v-for="v in allins" :key="v.id">
            <a-badge
              color="#4DCC66"
              :text="v.name"
              :style="{ marginBottom: '10px' }"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- 两个图表 -->
    <a-row :gutter="16">
      <a-col :lg="24" :xl="12">
        <a-spin :spinning="spinning1">
          <echart1 ref="echart1" @change="changeE1" />
        </a-spin>
      </a-col>
      <a-col :lg="24" :xl="12">
        <a-spin :spinning="spinning2">
          <echart2 ref="echart2" @change="changeE2" />
        </a-spin>
      </a-col>
    </a-row>
    <!-- 系统通知 -->
    <div class="card cardSys">
      <h3>系统消息</h3>
      <a-row :gutter="16">
        <a-col
          :sm="24"
          :md="12"
          v-for="(v,i) in timeoutarr"
          :key="i"
          class="cardSysMsg"
        >
          <img
            src="@/assets/image/icon_message.png"
            style="width: 20px; height: 20px"
            alt=""
          />
          <span v-if="v.is_exit === 0">
            请注意，{{
              v.health_level == 1
                ? "绿码"
                : v.health_level == 2
                ? "黄码"
                : "红码"
            }}人员{{ v.name }} <span v-if="v.is_timeout == 0">将</span
            ><span v-else>已</span>
            {{
              v.expire_data != "1974年01月31日" ? "在" + v.expire_data : ""
            }}到期，请及时更新。</span
          >
          <span v-else>请注意，{{ v.name }}已退场</span>
        </a-col>
      </a-row>
      <div class="loadmore" v-if="loadmore" @click="getTimeout">查看更多</div>
      <div class="loadmore" v-if="timeoutarr.length == 0">暂无数据</div>
    </div>
  </div>
</template>

<script>
import instance from "@/request/request";
import echart1 from "./components/echart1.vue";
import echart2 from "./components/echart2.vue";
import Echart from "@/components/Echart/index";
import * as echarts from "echarts";
export default {
  data() {
    return {
      labelEchart1: {},
      allp: 0, //总入场人数
      allpi: 0, //目前在场人数
      allye: 0, //黄码人数
      allgr: 0, //绿码人数
      allins: [], //总设备
      yevalue: 0, //黄码占比
      grvalue: 0, //绿码占比
      type1: 3,
      type2: 3,
      ps: [],
      spinning1: false,
      spinning2: false,
      timeoutarr: [], //
      page: 0,
      loadmore: false, //是否还有更多
      timeoutloading: false,
    };
  },
  watch: {
    "$store.state.config.project_id": {
      handler(newV, oldV) {
        //重新请求数据
        this.getdata();
        this.getPerson();
        this.page = 0;
        this.loadmore = true;
        this.timeoutarr = [];
        this.getTimeout();
      },
    },
  },
  components: { echart1, echart2, Echart },
  mounted() {
    this.getdata();
    this.getPerson();
    this.getTimeout();
    // const labelEchart1 = echarts.init(document.getElementById("labelEchart1"));
    // const labelEchart2 = echarts.init(document.getElementById("labelEchart2"));
    // var option1 = ;
    // labelEchart1.setOption(option1);
    // labelEchart2.setOption(option1);
    this.labelEchart1 = {
      xAxis: {
        type: "category",
      },
      yAxis: {
        show: false,
      },
      grid: {
        left: "-30",
        top: "0",
        right: "-30",
        bottom: "0",
      },
      series: [
        {
          data: [56, 86, 175, 140, 88, 67, 30, 60, 55, 80],
          type: "line",
          color: "rgba(255,255,255, 0.5)",
          smooth: true,
          showSymbol: false,
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: "rgba(255, 255, 255, 0.6)",
              },
              {
                offset: 1,
                color: "rgba(255, 255, 255, 0)",
              },
            ]),
          },
        },
      ],
    };
  },
  methods: {
    getdata() {
      instance.get("/home").then((res) => {
        this.allp = res.data.allp; //总入场人数
        this.allpi = res.data.allpi; //目前在场人数
        this.allye = res.data.allye; //黄码人数
        this.allgr = res.data.allgr; //绿码人数
        this.allins = res.data.allins; //总设备
        this.yevalue = res.data.yevalue;
        this.grvalue = res.data.grvalue;
      });
    },
    changeE1(type) {
      this.type1 = type;
      this.getPerson();
    },
    changeE2(type) {
      this.type2 = type;
      this.getTrain();
    },
    getPerson() {
      this.spinning1 = true;
      instance
        .post("/homePerson", { type: this.type1 })
        .then((res) => {
          // console.log(res);
          const moment = require("moment");
          const e3 = res.data.data.map((v) =>
            v.month ? v.month : v.day ? moment(v.day).format("D号") : ""
          );
          const e3d = res.data.data.map((v) => v.count);
          this.$refs.echart1.option.xAxis.data = e3;
          this.$refs.echart1.option.series[0].data = e3d;
          this.$refs.echart1.draw();
        })
        .finally(() => {
          this.spinning1 = false;
        });
    },
    getTrain() {
      this.spinning2 = true;
      instance
        .post("/homeTrain", { type: this.type2 })
        .then((res) => {
          // console.log(res);
          // const moment = require("moment");
          const e3 = res.data.t1.map((v) => v.name);

          const e3d1 = res.data.t1.map((v) => v.count);
          const e3d2 = res.data.t2.map((v) => v.count);
          this.$refs.echart2.option.xAxis.data = e3;
          this.$refs.echart2.option.series[0].data = e3d1;
          this.$refs.echart2.option.series[1].data = e3d2;
          this.$refs.echart2.draw();
        })
        .finally(() => {
          this.spinning2 = false;
        });
    },
    getTimeout() {
      if (this.timeoutloading) return;
      this.timeoutloading = true;
      this.page += 1;
      instance
        .get("/codetimeout?page=" + this.page)
        .then((res) => {
          this.timeoutarr.push(...res.data);
          if (res.data.length < 5) {
            this.loadmore = false;
          }
        })
        .finally(() => {
          this.timeoutloading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.home {
  .header {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(284px, 1fr));
    grid-gap: 20px;
    margin-bottom: 40px;
    width: 100%;
  }

  .item {
    aspect-ratio: 1/1;
    height: 200px;
    box-shadow: 0px 10px 20px #e6e8f0;
    border-radius: 12px;
    width: 100%;

    .item_title {
      font-size: 18px;
      height: 18px;
      font-weight: 400;
      line-height: 20px;
      color: rgba(255, 255, 255, 0.7);
      margin-bottom: 10px;
    }

    .number {
      display: flex;
      align-items: center;

      // margin-bottom: 10px;
      img {
        width: 32px;
        height: 32px;
        margin-right: 10px;
      }

      .number-class {
        color: #fff;
      }
    }

    .label {
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 22px;
      color: rgba(255, 255, 255, 0.7);
      margin-bottom: 23px;
    }

    .labelEchart {
      width: 100%;
      height: 38px;
    }

    .two {
      display: flex;
      justify-content: space-between;
    }
  }

  .item1,
  .item2,
  .item3,
  .item4,
  .item5 {
    padding: 24px 30px;
    box-sizing: border-box;
    box-shadow: 0px 10px 20px #e6e8f0;
  }

  .item1 {
    background: #1473fb;

    .label {
      color: #b9d5fd;
    }
  }

  .item2 {
    background: #33cce5;
  }

  .item3 {
    background: #f7ae41;
  }

  .item4 {
    background: #4dcc66;
  }

  .item5 {
    background: #fff;

    .list {
      margin-top: 10px;
      height: 100px;
      overflow-y: auto;
    }
  }

  .card {
    background: #ffffff;
    box-shadow: 0px 10px 20px #e6e8f0;
    opacity: 1;
    border-radius: 12px;
    overflow: hidden;
    margin-bottom: 40px;
  }

  .echartHead {
    padding-top: 26px;
    padding-right: 30px;
    padding-left: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    h3 {
      font-size: 18px;
      font-family: SourceHanSansSC-Regular;
      font-weight: 600;
      color: #011733;
    }
  }

  #echart1,
  #echart2 {
    width: 100%;
    height: 400px;
  }

  .w {
    height: 26px;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 26px;
    text-align: center;
    color: #585f6a;
    padding: 0 10px;
    background: #f5f6fa;
    border-radius: 3px;
    cursor: pointer;
  }

  .wa {
    background: #0054fe;
    color: #fff;
  }

  .cardSys {
    padding: 30px;
    box-sizing: border-box;
    margin-bottom: 0;
    background-image: url('~@/assets/image/homecode.png');
    background-size: 100px 100px;
    background-position: right 35px top 25px;
    background-repeat: no-repeat;
    h3 {
      font-size: 18px;
      font-weight: 600;
      line-height: 20px;
      color: #011733;
    }

    .cardSysMsg {
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 22px;
      color: #011733;
      margin-top: 15px;
      display: flex;
      align-items: center;
      img {
        margin-right: 20px;
        margin-bottom: -2px;
      }
    }
  }
}
.loadmore {
  text-align: center;
  margin-top: 20px;
  cursor: pointer;
}
</style>